import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type CurrentAdminService from 'garaje/services/current-admin';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';
import type MetricsService from 'garaje/services/metrics';
import type StateService from 'garaje/services/state';
import { AnalyticsEventNames } from 'garaje/utils/enums';

import type GlobalAnalyticsScreensIndexController from './controller';

export default class GlobalAnalyticsScreensIndexRoute extends Route {
  title = 'Screens · Global Analytics · Envoy';

  @service declare globalOverviewAccess: GlobalOverviewAccessService;
  @service declare router: RouterService;
  @service declare state: StateService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare metrics: MetricsService;

  afterModel(): void {
    this.#logMetrics();
  }

  setupController(controller: GlobalAnalyticsScreensIndexController, model: void, transition: Transition): void {
    super.setupController(controller, model, transition);

    if (this.globalOverviewAccess.canVisitScreensAnalytics) {
      void controller.fetchSigmaUrlTask.perform();
    }
  }

  redirect(): void {
    if (!this.globalOverviewAccess.canVisitScreensAnalytics) {
      this.router.transitionTo('unauthorized');
    }
  }

  #logMetrics(): void {
    const companyId = this.state?.currentCompany?.id;
    const details = {
      companyId,
      app: this.state.workplaceSubscription?.app,
      plan: this.state?.workplaceSubscription?.plan,
      userId: this.currentAdmin?.id || '',
      employeeId: this.currentAdmin.employee?.id || '',
    };
    this.metrics.trackEvent(AnalyticsEventNames.SCREENS_GLOBAL_DASHBOARD_VISITED, details);
    this.metrics.logMonitorEvent(AnalyticsEventNames.SCREENS_GLOBAL_DASHBOARD_VISITED, details);
  }
}
